export const headersConfig = {
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'API-KEY': process.env.REACT_APP_API_KEY,
  },
}
